export default __webpack_public_path__ + "static/favicon-edfb3cdd6f76b537b567e0ac32117911.ico";